(ns frontend.ui.component.dynamic-table.style
  (:require
   [herb.core :refer [<class]]
   [frontend.ui.style.theme.core :as theme]))

(defn container
  []
  {:position :relative})

(defn scroll-container
  []
  {:overflow         :auto
   :position         :relative
   :background-color "inherit"})

(defn dynamic-table
  []
  {:flex-direction   :column
   :font-size        :12px
   :min-width        :100%
   :border-collapse  :separate
   :background-color "inherit"})

(defn padding-bottom
  []
  {:padding-bottom "10px"})


(defn tbody
  []
  {:background "inherit"})
